import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import birthdayToAge from "../function/birthdayToAge.js";
import getUrl from '../function/getUrl'
import reloadIcon from "../icon/reload.svg";
import searchIcon from "../icon/search.svg";
import checkLogin from "../function/checkLogin.js"
import getDay from "../function/getDay"
const url= getUrl()
const token=sessionStorage.getItem("token")
//快速查詢學生
const GetStudentTrialListForHome = (props) => {
 
  let param = useParams(); //功能項目
  let togo = param.togo;
  let title = "體驗報名處理";
  let goLink = "/SingleStudentTrialView/";
  const workday=getDay(-7,"-")
  console.log(workday)
  //設計功能切換

  //進度條
  let loadingState = (
    <>
      <h5 className="text-info mt-5">資料載入中...</h5>
      <div className="progress w-50">
        <div
          className="progress-bar progress-bar-striped progress-bar-animated bg-info"
          role="progressbar"
          aria-valuenow="75"
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: "100%" }}
        ></div>
      </div>
    </>
  );
  const [studentList, setStudentList] = useState(loadingState);

  var imgStyle = {
    width: "20px",
    height: "20px",
  };
  function makeList(e) {
    setStudentList(loadingState);
    
  
    let studentArray = [];
    let name=""
    
    // fetch(`${url}/appGet/getStudentByTrialFlag?name=${name}&token=${token}`)
     fetch(`${url}/appGet/GetStudentTrialListForHome?name=${name}&token=${token}`)
      .then((res) => {
        return res.json();
      })
      .then((json) => {

      //   json.sort((a, b) => {
      //     var nameA = a.studentDBID;
      //     var nameB = b.studentDBID;
      //     if (nameA > nameB) {
      //         return -1;
      //     }
      //     if (nameA < nameB) {
      //         return 1;
      //     }
      //     return 0;
      // });

        for (let x in json) {
          let state=<span >{json[x]["nextStep"]}</span>
         
          if (json[x]["nextStep"]=="待追蹤"){
            state=<span className="text-danger">{json[x]["nextStep"]}</span>
          }
          let age = birthdayToAge(json[x].birthday, "-");
          if (json[x]["contactDate"]< workday){
            json[x]["contactDate"]=<span className="text-danger">{json[x]["contactDate"]} </span>
          }
          if (json[x]["contactDate"]=="尚未聯絡"){
            json[x]["contactDate"]=<span className="text-danger">尚未聯絡</span>
          }else{
            let date=json[x]["contactDate"]
            json[x]["contactDate"]=<span className="text-muted">{date}</span>
          }
          let singleStudent = (
            <tr
              onClick={() => {
                window.location.href = `${goLink}${json[x]["studentDBID"]}`;
              }}
              className="text-muted"
              style={{ textDecoration: "none" }}
            >
              <td>{json[x]["studentDBID"]}</td>
              <td>{json[x]["name"]}<br/><small>{json[x]["nickName"]}</small></td>
        
              <td>{json[x]["birthday"]}</td>
              <td>{age[0]}</td>
              <td>{json[x]["parent"]}</td>
              <td>{json[x]["createDate"].substring(0,16)}</td>
              <td>{json[x]["amount"]}</td>
              <td>{json[x]["contactDate"]}</td>
              <td>{state}</td>
              
            </tr>
          );
          if(state!="結案"){
            studentArray.push(singleStudent);
          }
          
        }
      })
      .then(() => {
        setStudentList(studentArray);
      });
  }


  useEffect(() => {
    makeList();
   
  }, []);

  return (
    <>

<div className="card mt-2" style={{ width: "18rem;" }}>
        <div className="card-body alert-success">
          <h5 className="card-title">體驗名單待處理 共計{studentList.length} 筆</h5>
          <small>最後連絡天數超過一周會標示為紅色</small>
          <div className="card-text alert-light rounded p-2">
          <table class="table table-striped">
          <thead>
            <tr className="text-center">
              <th scope="col">編號</th>
              <th scope="col">姓名/暱稱</th>
              <th scope="col">生日</th>
              <th scope="col">年紀</th>
              <th scope="col">家長</th>
              <th scope="col">建立日期</th>
              <th scope="col">連絡次數</th>
              <th scope="col">連絡日期</th>
              <th scope="col">狀態</th>
              {/* <th scope="col">狀態</th> */}
            </tr>
          </thead>
          <tbody className="text-center">{studentList}</tbody>
        </table>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default GetStudentTrialListForHome;
